export enum LotType {
  None = 0,
  TollRoad,
  ParkingLot
}

export enum LotBusinessModelType {
  None = 0,
  LatePayment,
  Surcharge,
  ServiceFee,
  Discount
}

export enum AreaType {
  None = 0,
  TollRoads,
  ParkingLots
}

export enum CountryType {
  None = 0,
  Norway,
  Sweden,
  Denmark,
  Estonia,
  Latvia,
  Lithuania,
  Poland,
  Germany,
  France,
  Netherland = 10,
  Netherlands = Netherland,
  Belgium,
  Russia,
  Austria,
  Bulgaria,
  Croatia,
  Cyprus,
  CzechRepublic,
  Gibraltar,
  Greece,
  Hungary,
  Ireland,
  Italy,
  Luxembourg,
  Malta,
  Portugal,
  Slovakia,
  Slovenia,
  Spain,
  UnitedKingdom,
  Finland,
  Romania,
  Switzerland,
  Serbia,
  Albania,
  Iceland,
  Ukraine,
  Kosovo,
  Montenegro,
  Macedonia,
  Moldova,
  Monaco,
  FaroeIslands,
  Belarus,
  BosniaHerzegovina,
  Andorra
}

export enum PaymentSourceFeatureType {
  None = 0,
  Alpr = 1 << 0,
  Subscription = 1 << 1
}

export enum DebitorType {
  None = 0,
  Individual,
  Company
}

export enum UserPhoneType {
  None = 0,
  Landline,
  Mobile,
  Fax
}

export enum UserAddressType {
  None = 0,
  Visiting,
  Postal,
  Billing
}

export enum UserPaymentSourceType {
  None = 0,
  Vipps = 2,
  Invoice = 3,
  PaymentLink = 4,
  CreditCardNetAxept = 5
}

export enum UserPaymentCreditCardVendorSourceType {
  None = 0,
  Visa = 1,
  Mastercard = 2,
  MastercardSweden = 3,
  MastercardDenmark = 4,
  VisaSweden = 5,
  VisaDenmark = 6,
  VisaElectron = 7
}

export enum VatRateType {
  None = 0,
  Vat25 = 1
}

export enum LogLevel {
  Trace = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Fatal = 5
}

export enum PowerAdapterType {
  None = 0,
  Elko = 1,
  YoyoPower = 2,
  Sikom = 3
}

export enum BarrierOpenerType {
  RelayCard = 1
}

export enum YouparkAccessApplicationType {
  AccessPad = 1
}

export enum CollectionProviderVendorSourceType {
  FinterAs = 1,
  Epc = 3
}

export enum RemitCriteriaType {
  Daily = 1,
  Monthly = 2
}

export enum RemitAllocationTrancheValueType {
  Amount = 1,
  Percent = 2,
  Remainder = 3
}

export enum InvoiceType {
  None = 0,
  Subscription = 1,
  Alpr = 2
}

export enum YoupayTransactionVendorType {
  None = 0,
  Vipps = 2,
  CreditCardDibs = 3,
  Invoice = 4,
  CreditCardNetAxept = 5
}

export enum SubscriptionBillableOccurenceType {
  None = 0,
  Initial,
  Renewal
}

export enum SubscriptionBillablePaymentStateType {
  None = 0,
  PendingPostPayBilling,
  Billed,
  PendingPreApproval,
  BilledFreeOfCharge,
  PendingPrePayment,
  ErrorPendingPrePaymentFailed
}

export enum SubscriptionValidityPeriodType {
  None = 0,
  Week,
  Month,
  Year,
  HalfYear,
  Quarter
}

export enum YoupayTransactionType {
  None = 0,
  Kiosk,
  PaymentSource,
  Subscription
}

export enum GlobalViewModelType {
  Account = 0,
  Subscription,
  ReloadCurrent
}

export enum VehicleInfoTonnagePriceCategoryType {
  None = 0,
  LessThanOrEqualTo3500Kilos,
  GreaterThan3500Kilos,
  CarTrailer,
  TruckCarTrailer,
  Tractor,
  Motorbike,
  CampingCarTrailer,
  CampingCar,
  ElectricCar,
  GreaterThan7500Kilos
}

export enum LotSizeCategory {
  Unknown = 0,
  Small = 1,
  Medium = 2,
  Large = 3
}

export enum DirectionType {
  None = 0,
  Enter = 1,
  Exit = 2
}

export enum ApplicationType {
  Youpark = 1 << 4, // 16
  Youpay = 1 << 5, // 32
  YouparkOffloader = 1 << 6, // 64
  Access = 1 << 7, // 128
  FreeVisitKiosk = 1 << 8 // 256
}

export enum SubscriptionCommunicationType {
  None = 0,
  ExpiresInXDays,
  RenewalInXDays,
  Renewal,
  Expired,
  DeletedByUserId,
  RefundYoupayTransaction,
  AddVehicle,
  InitialPurchase,
  InitialPaymentLink,
  RenewalPaymentLink
}

export enum BrowserType {
  Chrome = 0,
  Edge,
  Firefox,
  Safari,
  Other
}

export enum DeviceType {
  Android = "Android",
  iOS = "iOS",
  Desktop = "Desktop"
}

export enum SharedSubscriptionPricingType {
  None = 0,
  Fixed,
  PerSpace
}

export enum SharedSubscriptionInvoicingType {
  None = 0,
  Advance,
  Post
}

export enum TodoStatusType {
  None = 0,
  Approved,
  Declined
}

export enum BookingType {
  None = 0,
  Subscription
}

export enum LotBookingReservationType {
  None = 0,
  Space,
  SubscriptionSpace
}

export enum LotBookingReservationChangeLogType {
  None = 0,
  AdjustedBooking,
  CancelledBooking,
  ExpiredBooking
}

export enum AccessAuditType {
  None = 0,
  YouParkAlprResult = 1,
  AccessPadOpenBarrier = 100
}

export enum PriceMatrixCalculatorType {
  None = 0,
  RunInPeriod,
  MinimumPrice,
  PricePerUnit,
  Overstay
}

export enum PriceMatrixPeriodType {
  None = 0,
  Fixed,
  Floating
}

export enum PriceMatrixPricePerUnitType {
  None = 0,
  Minute = 1,
  Hour = 2,
  Week = 4,
  Visit = 6
}

export enum RemitPaymentStatus {
  Initial = 0,
  InitialReadyForSendToBank = 1,
  SendingToBank = 10,
  Booked = 100,
  ManuallyProcessed = 101,
  ManualProcessingBankGenericError = 1000,
  ManualProcessingBankInternalErrorCode = 1001,
  ManualProcessingBankInvalidDestinationAccount = 1002,
  ManualProcessingBankDestinationAccountClosed = 1003,
  ManualProcessingBankInvalidSourceAccount = 1004,
  ManualProcessingBankInsufficientBalancePending = 1005,
  ManualProcessingBankInsufficientBalanceRejected = 1006,
  BankCancelledByDebtor = 1007,
  ManualProcessingBankInvalidDate = 1008,
  ManualProcessingBankMissingCreditorNameOrAddress = 1009,
  ManualProcessingDirectPaymentDestinationAccount = 1010
}

export enum YouparkInvoiceCreditReasonType {
  None = 0,
  VehicleChangeOfOwnership = 1,
  VehicleOwnerDeceased = 2,
  VehicleWrecked = 3,
  VehicleOwnerInvalidLeasingAddress = 4,
  VehicleOwnerExpat = 5,
  VehicleForeignClosed = 6,
  VehicleOwnerOrganizationDissolved = 7,
  VehicleLicensePlateNotFound = 8,
  VehicleOwnerConfidential = 9,
  VehicleOwnerCompanyOrganizationNbDoesNotExist = 10,
  VehicleOwnerUnableIdentifyAddress = 11,
  RequestedByCustomer = 12,
  Misread = 13,
  EmergencyVehicle = 14,
  TechnicalFault = 15,
  SubscriptionRelated = 16
}

export enum YoupayCreditTransactionReasonType {
  None = 0,
  Credit = 1,
  Coupon = 2,
  FreeVisit = 3,
  RequestedByCustomer = 4,
  Misread = 5,
  EmergencyVehicle = 6,
  TechnicalFault = 7,
  SubscriptionRelated = 8,
  VehicleChangeOfOwnership = 9
}
